export default __webpack_public_path__ + "static/media/garymod.8603c6c0.jpeg";